import { render, staticRenderFns } from "./PeerMatchControl.vue?vue&type=template&id=1d7fa21e&scoped=true&"
import script from "./PeerMatchControl.vue?vue&type=script&lang=js&"
export * from "./PeerMatchControl.vue?vue&type=script&lang=js&"
import style0 from "./PeerMatchControl.vue?vue&type=style&index=0&id=1d7fa21e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7fa21e",
  null
  
)

export default component.exports